/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AgentCodeResponse } from '../models/agent-code-response';
import { AgentFieldHistoryResponse } from '../models/agent-field-history-response';
import { AgentResponse } from '../models/agent-response';
import { deleteApiAgentV1Id } from '../fn/agent/delete-api-agent-v-1-id';
import { DeleteApiAgentV1Id$Params } from '../fn/agent/delete-api-agent-v-1-id';
import { GetAgentsResponse } from '../models/get-agents-response';
import { getApiAgentV1Id$Json } from '../fn/agent/get-api-agent-v-1-id-json';
import { GetApiAgentV1Id$Json$Params } from '../fn/agent/get-api-agent-v-1-id-json';
import { getApiAgentV1Id$Plain } from '../fn/agent/get-api-agent-v-1-id-plain';
import { GetApiAgentV1Id$Plain$Params } from '../fn/agent/get-api-agent-v-1-id-plain';
import { patchApiAgentV1Id$Json } from '../fn/agent/patch-api-agent-v-1-id-json';
import { PatchApiAgentV1Id$Json$Params } from '../fn/agent/patch-api-agent-v-1-id-json';
import { patchApiAgentV1Id$Plain } from '../fn/agent/patch-api-agent-v-1-id-plain';
import { PatchApiAgentV1Id$Plain$Params } from '../fn/agent/patch-api-agent-v-1-id-plain';
import { postApiAgentV1$Json } from '../fn/agent/post-api-agent-v-1-json';
import { PostApiAgentV1$Json$Params } from '../fn/agent/post-api-agent-v-1-json';
import { postApiAgentV1$Plain } from '../fn/agent/post-api-agent-v-1-plain';
import { PostApiAgentV1$Plain$Params } from '../fn/agent/post-api-agent-v-1-plain';
import { postApiAgentV1Create$Json } from '../fn/agent/post-api-agent-v-1-create-json';
import { PostApiAgentV1Create$Json$Params } from '../fn/agent/post-api-agent-v-1-create-json';
import { postApiAgentV1Create$Plain } from '../fn/agent/post-api-agent-v-1-create-plain';
import { PostApiAgentV1Create$Plain$Params } from '../fn/agent/post-api-agent-v-1-create-plain';
import { postApiAgentV1Export$Json } from '../fn/agent/post-api-agent-v-1-export-json';
import { PostApiAgentV1Export$Json$Params } from '../fn/agent/post-api-agent-v-1-export-json';
import { postApiAgentV1Export$Plain } from '../fn/agent/post-api-agent-v-1-export-plain';
import { PostApiAgentV1Export$Plain$Params } from '../fn/agent/post-api-agent-v-1-export-plain';
import { postApiAgentV1GenerateCode$Json } from '../fn/agent/post-api-agent-v-1-generate-code-json';
import { PostApiAgentV1GenerateCode$Json$Params } from '../fn/agent/post-api-agent-v-1-generate-code-json';
import { postApiAgentV1GenerateCode$Plain } from '../fn/agent/post-api-agent-v-1-generate-code-plain';
import { PostApiAgentV1GenerateCode$Plain$Params } from '../fn/agent/post-api-agent-v-1-generate-code-plain';
import { postApiAgentV1IdHistory$Json } from '../fn/agent/post-api-agent-v-1-id-history-json';
import { PostApiAgentV1IdHistory$Json$Params } from '../fn/agent/post-api-agent-v-1-id-history-json';
import { postApiAgentV1IdHistory$Plain } from '../fn/agent/post-api-agent-v-1-id-history-plain';
import { PostApiAgentV1IdHistory$Plain$Params } from '../fn/agent/post-api-agent-v-1-id-history-plain';
import { postApiAgentV1IdHistoryExport$Json } from '../fn/agent/post-api-agent-v-1-id-history-export-json';
import { PostApiAgentV1IdHistoryExport$Json$Params } from '../fn/agent/post-api-agent-v-1-id-history-export-json';
import { postApiAgentV1IdHistoryExport$Plain } from '../fn/agent/post-api-agent-v-1-id-history-export-plain';
import { PostApiAgentV1IdHistoryExport$Plain$Params } from '../fn/agent/post-api-agent-v-1-id-history-export-plain';
import { postApiAgentV1IdLock } from '../fn/agent/post-api-agent-v-1-id-lock';
import { PostApiAgentV1IdLock$Params } from '../fn/agent/post-api-agent-v-1-id-lock';
import { postApiAgentV1IdUnlock } from '../fn/agent/post-api-agent-v-1-id-unlock';
import { PostApiAgentV1IdUnlock$Params } from '../fn/agent/post-api-agent-v-1-id-unlock';
import { postApiAgentV1Replace$Json } from '../fn/agent/post-api-agent-v-1-replace-json';
import { PostApiAgentV1Replace$Json$Params } from '../fn/agent/post-api-agent-v-1-replace-json';
import { postApiAgentV1Replace$Plain } from '../fn/agent/post-api-agent-v-1-replace-plain';
import { PostApiAgentV1Replace$Plain$Params } from '../fn/agent/post-api-agent-v-1-replace-plain';

@Injectable({ providedIn: 'root' })
export class AgentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiAgentV1()` */
  static readonly PostApiAgentV1Path = '/private/v1/agents';

  /**
   * Retrieves the list of all available  agents.
   *
   * Retrieves the list of all available  agents.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1$Plain$Response(params?: PostApiAgentV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAgentsResponse>> {
    return postApiAgentV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available  agents.
   *
   * Retrieves the list of all available  agents.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1$Plain(params?: PostApiAgentV1$Plain$Params, context?: HttpContext): Observable<GetAgentsResponse> {
    return this.postApiAgentV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAgentsResponse>): GetAgentsResponse => r.body)
    );
  }

  /**
   * Retrieves the list of all available  agents.
   *
   * Retrieves the list of all available  agents.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1$Json$Response(params?: PostApiAgentV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAgentsResponse>> {
    return postApiAgentV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all available  agents.
   *
   * Retrieves the list of all available  agents.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1$Json(params?: PostApiAgentV1$Json$Params, context?: HttpContext): Observable<GetAgentsResponse> {
    return this.postApiAgentV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAgentsResponse>): GetAgentsResponse => r.body)
    );
  }

  /** Path part for operation `postApiAgentV1Create()` */
  static readonly PostApiAgentV1CreatePath = '/private/v1/agents/create';

  /**
   * Create a new agent.
   *
   * Create a new agent.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1Create$Plain$Response(params?: PostApiAgentV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentResponse>> {
    return postApiAgentV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new agent.
   *
   * Create a new agent.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1Create$Plain(params?: PostApiAgentV1Create$Plain$Params, context?: HttpContext): Observable<AgentResponse> {
    return this.postApiAgentV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentResponse>): AgentResponse => r.body)
    );
  }

  /**
   * Create a new agent.
   *
   * Create a new agent.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1Create$Json$Response(params?: PostApiAgentV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentResponse>> {
    return postApiAgentV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new agent.
   *
   * Create a new agent.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1Create$Json(params?: PostApiAgentV1Create$Json$Params, context?: HttpContext): Observable<AgentResponse> {
    return this.postApiAgentV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentResponse>): AgentResponse => r.body)
    );
  }

  /** Path part for operation `postApiAgentV1IdLock()` */
  static readonly PostApiAgentV1IdLockPath = '/private/v1/agents/{id}/lock';

  /**
   * Lock agent by internal ID.
   *
   * Lock agent by internal ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1IdLock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiAgentV1IdLock$Response(params: PostApiAgentV1IdLock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiAgentV1IdLock(this.http, this.rootUrl, params, context);
  }

  /**
   * Lock agent by internal ID.
   *
   * Lock agent by internal ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1IdLock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiAgentV1IdLock(params: PostApiAgentV1IdLock$Params, context?: HttpContext): Observable<void> {
    return this.postApiAgentV1IdLock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiAgentV1IdUnlock()` */
  static readonly PostApiAgentV1IdUnlockPath = '/private/v1/agents/{id}/unlock';

  /**
   * Unlock agent by internal ID.
   *
   * Unlock agent by internal ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1IdUnlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiAgentV1IdUnlock$Response(params: PostApiAgentV1IdUnlock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiAgentV1IdUnlock(this.http, this.rootUrl, params, context);
  }

  /**
   * Unlock agent by internal ID.
   *
   * Unlock agent by internal ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1IdUnlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiAgentV1IdUnlock(params: PostApiAgentV1IdUnlock$Params, context?: HttpContext): Observable<void> {
    return this.postApiAgentV1IdUnlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getApiAgentV1Id()` */
  static readonly GetApiAgentV1IdPath = '/private/v1/agents/{id}';

  /**
   * Retrieves a specific agent by its internal ID.
   *
   * Retrieves a specific agent by its internal ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAgentV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAgentV1Id$Plain$Response(params: GetApiAgentV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentResponse>> {
    return getApiAgentV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a specific agent by its internal ID.
   *
   * Retrieves a specific agent by its internal ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAgentV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAgentV1Id$Plain(params: GetApiAgentV1Id$Plain$Params, context?: HttpContext): Observable<AgentResponse> {
    return this.getApiAgentV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentResponse>): AgentResponse => r.body)
    );
  }

  /**
   * Retrieves a specific agent by its internal ID.
   *
   * Retrieves a specific agent by its internal ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiAgentV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAgentV1Id$Json$Response(params: GetApiAgentV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentResponse>> {
    return getApiAgentV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves a specific agent by its internal ID.
   *
   * Retrieves a specific agent by its internal ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiAgentV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiAgentV1Id$Json(params: GetApiAgentV1Id$Json$Params, context?: HttpContext): Observable<AgentResponse> {
    return this.getApiAgentV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentResponse>): AgentResponse => r.body)
    );
  }

  /** Path part for operation `deleteApiAgentV1Id()` */
  static readonly DeleteApiAgentV1IdPath = '/private/v1/agents/{id}';

  /**
   * Delete the Agent to by its id.
   *
   * Delete the Agent to by its id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiAgentV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiAgentV1Id$Response(params: DeleteApiAgentV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiAgentV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete the Agent to by its id.
   *
   * Delete the Agent to by its id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiAgentV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiAgentV1Id(params: DeleteApiAgentV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiAgentV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchApiAgentV1Id()` */
  static readonly PatchApiAgentV1IdPath = '/private/v1/agents/{id}';

  /**
   * Partially updates an existing agent.
   *
   * Partially updates an existing agent.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchApiAgentV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchApiAgentV1Id$Plain$Response(params: PatchApiAgentV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentResponse>> {
    return patchApiAgentV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Partially updates an existing agent.
   *
   * Partially updates an existing agent.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchApiAgentV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchApiAgentV1Id$Plain(params: PatchApiAgentV1Id$Plain$Params, context?: HttpContext): Observable<AgentResponse> {
    return this.patchApiAgentV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentResponse>): AgentResponse => r.body)
    );
  }

  /**
   * Partially updates an existing agent.
   *
   * Partially updates an existing agent.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchApiAgentV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchApiAgentV1Id$Json$Response(params: PatchApiAgentV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentResponse>> {
    return patchApiAgentV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Partially updates an existing agent.
   *
   * Partially updates an existing agent.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchApiAgentV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchApiAgentV1Id$Json(params: PatchApiAgentV1Id$Json$Params, context?: HttpContext): Observable<AgentResponse> {
    return this.patchApiAgentV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentResponse>): AgentResponse => r.body)
    );
  }

  /** Path part for operation `postApiAgentV1GenerateCode()` */
  static readonly PostApiAgentV1GenerateCodePath = '/private/v1/agents/generate-code';

  /**
   * Generates a new agent code.
   *
   * Generates a new agent code.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1GenerateCode$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1GenerateCode$Plain$Response(params?: PostApiAgentV1GenerateCode$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentCodeResponse>> {
    return postApiAgentV1GenerateCode$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Generates a new agent code.
   *
   * Generates a new agent code.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1GenerateCode$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1GenerateCode$Plain(params?: PostApiAgentV1GenerateCode$Plain$Params, context?: HttpContext): Observable<AgentCodeResponse> {
    return this.postApiAgentV1GenerateCode$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentCodeResponse>): AgentCodeResponse => r.body)
    );
  }

  /**
   * Generates a new agent code.
   *
   * Generates a new agent code.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1GenerateCode$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1GenerateCode$Json$Response(params?: PostApiAgentV1GenerateCode$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentCodeResponse>> {
    return postApiAgentV1GenerateCode$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Generates a new agent code.
   *
   * Generates a new agent code.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1GenerateCode$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1GenerateCode$Json(params?: PostApiAgentV1GenerateCode$Json$Params, context?: HttpContext): Observable<AgentCodeResponse> {
    return this.postApiAgentV1GenerateCode$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentCodeResponse>): AgentCodeResponse => r.body)
    );
  }

  /** Path part for operation `postApiAgentV1Export()` */
  static readonly PostApiAgentV1ExportPath = '/private/v1/agents/export';

  /**
   * Export agents to CSV file report.
   *
   * Export agents to CSV file report.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1Export$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1Export$Plain$Response(params?: PostApiAgentV1Export$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiAgentV1Export$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export agents to CSV file report.
   *
   * Export agents to CSV file report.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1Export$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1Export$Plain(params?: PostApiAgentV1Export$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiAgentV1Export$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export agents to CSV file report.
   *
   * Export agents to CSV file report.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1Export$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1Export$Json$Response(params?: PostApiAgentV1Export$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiAgentV1Export$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export agents to CSV file report.
   *
   * Export agents to CSV file report.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1Export$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1Export$Json(params?: PostApiAgentV1Export$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiAgentV1Export$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `postApiAgentV1IdHistory()` */
  static readonly PostApiAgentV1IdHistoryPath = '/private/v1/agents/{id}/history';

  /**
   * Retrieves the list of all modification done to the agent with the provided ID.
   *
   * Retrieves the list of all modification done to the agent with the provided ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1IdHistory$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1IdHistory$Plain$Response(params: PostApiAgentV1IdHistory$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentFieldHistoryResponse>> {
    return postApiAgentV1IdHistory$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all modification done to the agent with the provided ID.
   *
   * Retrieves the list of all modification done to the agent with the provided ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1IdHistory$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1IdHistory$Plain(params: PostApiAgentV1IdHistory$Plain$Params, context?: HttpContext): Observable<AgentFieldHistoryResponse> {
    return this.postApiAgentV1IdHistory$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentFieldHistoryResponse>): AgentFieldHistoryResponse => r.body)
    );
  }

  /**
   * Retrieves the list of all modification done to the agent with the provided ID.
   *
   * Retrieves the list of all modification done to the agent with the provided ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1IdHistory$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1IdHistory$Json$Response(params: PostApiAgentV1IdHistory$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentFieldHistoryResponse>> {
    return postApiAgentV1IdHistory$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all modification done to the agent with the provided ID.
   *
   * Retrieves the list of all modification done to the agent with the provided ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1IdHistory$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1IdHistory$Json(params: PostApiAgentV1IdHistory$Json$Params, context?: HttpContext): Observable<AgentFieldHistoryResponse> {
    return this.postApiAgentV1IdHistory$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgentFieldHistoryResponse>): AgentFieldHistoryResponse => r.body)
    );
  }

  /** Path part for operation `postApiAgentV1IdHistoryExport()` */
  static readonly PostApiAgentV1IdHistoryExportPath = '/private/v1/agents/{id}/history-export';

  /**
   * Export the list of all modification done to the agent with the provided ID.
   *
   * Export the list of all modification done to the agent with the provided ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1IdHistoryExport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1IdHistoryExport$Plain$Response(params: PostApiAgentV1IdHistoryExport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiAgentV1IdHistoryExport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the list of all modification done to the agent with the provided ID.
   *
   * Export the list of all modification done to the agent with the provided ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1IdHistoryExport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1IdHistoryExport$Plain(params: PostApiAgentV1IdHistoryExport$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiAgentV1IdHistoryExport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export the list of all modification done to the agent with the provided ID.
   *
   * Export the list of all modification done to the agent with the provided ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1IdHistoryExport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1IdHistoryExport$Json$Response(params: PostApiAgentV1IdHistoryExport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiAgentV1IdHistoryExport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the list of all modification done to the agent with the provided ID.
   *
   * Export the list of all modification done to the agent with the provided ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1IdHistoryExport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1IdHistoryExport$Json(params: PostApiAgentV1IdHistoryExport$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiAgentV1IdHistoryExport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `postApiAgentV1Replace()` */
  static readonly PostApiAgentV1ReplacePath = '/private/v1/agents/replace';

  /**
   * Endpoint to replace an agent by its id and returns a CSV file containing all updated customers.
   *
   * This endpoint allows you to replace an existing agent with a new one by providing the old agent's id and the new agent's id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1Replace$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1Replace$Plain$Response(params?: PostApiAgentV1Replace$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiAgentV1Replace$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Endpoint to replace an agent by its id and returns a CSV file containing all updated customers.
   *
   * This endpoint allows you to replace an existing agent with a new one by providing the old agent's id and the new agent's id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1Replace$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1Replace$Plain(params?: PostApiAgentV1Replace$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiAgentV1Replace$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Endpoint to replace an agent by its id and returns a CSV file containing all updated customers.
   *
   * This endpoint allows you to replace an existing agent with a new one by providing the old agent's id and the new agent's id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiAgentV1Replace$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1Replace$Json$Response(params?: PostApiAgentV1Replace$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiAgentV1Replace$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Endpoint to replace an agent by its id and returns a CSV file containing all updated customers.
   *
   * This endpoint allows you to replace an existing agent with a new one by providing the old agent's id and the new agent's id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiAgentV1Replace$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiAgentV1Replace$Json(params?: PostApiAgentV1Replace$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiAgentV1Replace$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
